import { useMemo } from 'react';
import { motion } from 'framer-motion';
import { useScrollSpy } from 'root/src/client/v2/_pages/drop/redesign/useScrollSpy';
import { cn } from 'root/src/client/v2/common/helpers/cn';
import { REDESIGN_NAV_STICKY_TOP_CLASS } from 'root/src/client/v2/layout/helpers/redesignNavbar';
const scrollToSection = (id) => {
    var _a;
    (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
};
export const DropSectionNav = ({ sections }) => {
    const ids = useMemo(() => sections.map(section => section.id), [sections]);
    const active = useScrollSpy(ids);
    return (<div className={cn('sticky z-40 transform-gpu border-b border-solid border-white/[0.06] bg-background/80 backdrop-blur-xl', REDESIGN_NAV_STICKY_TOP_CLASS)}>
			<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
				<nav className="flex gap-0.5 overflow-x-auto">
					{sections.map((section) => {
            const { Icon } = section;
            const isActive = active === section.id;
            return (<button key={section.id} type="button" onClick={() => scrollToSection(section.id)} className={cn('relative flex items-center gap-2 whitespace-nowrap px-4 py-3.5 text-sm font-medium transition-colors', isActive ? 'text-neon-cyan' : 'text-muted-foreground hover:text-foreground')}>
								<Icon sx={{ fontSize: 16 }}/>
								{section.label}
								{isActive && (<motion.span layoutId="drop-section-underline" className="absolute inset-x-2 bottom-0 h-[2px] rounded-full bg-neon-cyan shadow-[0_0_8px_2px_hsl(var(--neon-cyan)/0.4)]" transition={{ type: 'spring', stiffness: 380, damping: 32 }}/>)}
							</button>);
        })}
				</nav>
			</div>
		</div>);
};
